import { cn } from '@/utils/methods';
import React, { InputHTMLAttributes, forwardRef } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  suffix?: string;
  label?: string;
  labelClass?: string;
  hint?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', suffix, label, labelClass, hint, ...props }, ref) => {
    return (
      <>
        {label &&
          <label className={cn("block text-[14px] font-semibold text-primary-black mb-3", labelClass)}>{label}</label>
        }
        <div className={suffix ? "flex items-center rounded-[12px] border border-text-primary bg-white px-4 py-3" : 'w-full'}>
          <input
            ref={ref}
            className={`${className}`}
            {...props}
          />
          {suffix &&
            <span className="text-[12px] text-text-primary font-semibold shrink-0 ml-2">{suffix}</span>
          }
        </div>
        {hint && (
          <p className="mt-2 text-[14px] text-text-primary tracking-[0.4px] font-normal">{hint}</p>
        )}
      </>

    );
  }
);

Input.displayName = 'Input';
export default Input;
